import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {AuthService} from "../auth/auth.service";


@Injectable({
  providedIn: 'root'
})
export class RedirectGuardService implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // Add cases for each flow type
    if (this.salesforceCheck(state.url)) {
      this.salesforceParse(route)
      this.router.navigate(['onboard/dashboard'])
      return true;
    } else {
      this.router.navigate(['onboard/dashboard'])
      return true;
    }
  }

  salesforceParse(route: ActivatedRouteSnapshot) {
    localStorage.setItem('salesForceQuery', JSON.stringify(route.queryParams));
  }

  salesforceCheck(url: string): boolean {
    return url!.indexOf('Salesforce') > -1;
  }
}
